import React, { useContext, useCallback, useMemo } from "react";
import _ from "lodash";
import { BreakpointTrackerContext } from "@jutro/layout";
import { WizardPage, wizardProps } from "@xengage/gw-portals-wizard-react";
import { ViewModelForm, withViewModelService } from "@xengage/gw-portals-viewmodel-react";
import { useValidation } from "@xengage/gw-portals-validation-react";
import { readViewModelValue } from "@xengage/gw-jutro-adapters-react";
import { EntityUtil } from '@xengage/gw-portals-util-js';
import { PremierConstants } from "premier-constant-service";
import { useUpdateSubmissionServices, validationUtil } from "premier-capability-hooks";
import metadata from "./TinyHomesPage.metadata.json5";
import styles from "../../SpecialtyPersonalStyles.module.scss"
import TinyHomesDetails from "../../components/TinyHomes/TinyHomesDetails/TinyHomesDetails";

function TinyHomesPage(props) {
  const {
    wizardData: submissionVM,
    updateWizardData,
    viewModelService
  } = props;
  const breakpoint = useContext(BreakpointTrackerContext);
  const { onValidate, initialValidation } = useValidation(
    "TinyHomesPage"
  );
  const { updateSubmission } = useUpdateSubmissionServices();
  const { lineName } = PremierConstants;

  const onNext = useCallback(async () => {
    const productCode = _.get(submissionVM.value, "baseData.productCode");
    // eslint-disable-next-line security/detect-object-injection
    const lobLineName = productCode ? lineName[productCode] : "";
    const response = await updateSubmission(
      lobLineName,
      "TinyHomesPage",
      submissionVM
    );

    submissionVM.value = response;

    return submissionVM;
  }, [lineName, submissionVM, updateSubmission]);

  const addTinyHomes = useCallback(async () => {

    const timyhomesObj = {
      tempID: EntityUtil.nextId(),
      propertyDetails: {
        isValidationReq: true
      },      
      otherExpo: {
        isValidationReq: true
      }
    };

    const { _xCenter, _dtoName } = submissionVM.lobData.perLine.coverables.tinyHomesCoverable.tinyHomes;

    const tinyhomesVM = viewModelService.create(timyhomesObj, _xCenter, _dtoName);    
    
    submissionVM.lobData.perLine.coverables.tinyHomesCoverable.tinyHomes.value = submissionVM.lobData.perLine.coverables.tinyHomesCoverable.tinyHomes.value || []

    submissionVM.lobData.perLine.coverables.tinyHomesCoverable.tinyHomes.pushElement(
      tinyhomesVM
    );
    updateWizardData(submissionVM);
  },
    [submissionVM, viewModelService, updateWizardData]
  );

  const tinyhomesOverrides = useMemo(() => {
    const tinyhomesArray = _.get(submissionVM, 'lobData.perLine.coverables.tinyHomesCoverable.tinyHomes', []);
    let overrides = [];

    if (!_.isEmpty(tinyhomesArray)) {
      overrides = tinyhomesArray?.children.map((tinyhomes, index) => ({
        [`tinyHomesDetailsComponent${index}`]: {
          overrideProps: {
            "@field": {
              // apply to all fields
              showRequired: true,
              labelPosition: "left",
            },
          },
          submissionVM,
          updateWizardData,
          pathUpdated: `lobData.perLine.coverables.tinyHomesCoverable.tinyHomes.children[${index}]`,
          tinyhomesVM: tinyhomes,
          index,
          viewModelService
        }
      }));
    }

    return Object.assign({}, ...overrides);
  }, [submissionVM, updateWizardData, viewModelService]);


  const onSave = useCallback(
    async () => {
      const subVMCopy = _.clone(submissionVM)
      const productCode = _.get(subVMCopy.value, 'baseData.productCode');

      validationUtil.unSetIsValidationReqFlag(subVMCopy.lobData.perLine.coverables.tinyHomesCoverable.tinyHomes.value, ' ')

      const lobLineName = productCode ? lineName[productCode] : '';
      await updateSubmission(lobLineName, 'TinyHomesPage', subVMCopy);
                      
      return submissionVM;
    },
    [lineName, submissionVM, updateSubmission]
  );

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const overrideProps = {
    "@field": {
      showRequired: true,
      labelPosition: breakpoint === "desktop" ? "left" : "top",
    },
    ...tinyhomesOverrides,
  };

  const resolvers = {
    resolveCallbackMap: {
      onValidate,
      addTinyHomes,
    },
    resolveComponentMap: {
      tinyHomesDetailsComponent: TinyHomesDetails
    },
    resolveClassNameMap: styles
  };

  const readValue = useCallback(
    (id, path) => readViewModelValue(metadata.pageContent, submissionVM, id, path, overrideProps),
    [submissionVM, overrideProps]
  );

  const isDisableNext = () =>
    !submissionVM.lobData.perLine.coverables.tinyHomesCoverable.tinyHomes
      .aspects.subtreeValid;

  return (
    <WizardPage
      onNext={onNext}
      onSave={onSave}
      skipWhen={initialValidation}
      disableNext={isDisableNext()}
    >
      <ViewModelForm
        uiProps={metadata.pageContent}
        model={submissionVM}
        onModelChange={updateWizardData}
        overrideProps={overrideProps}
        onValidationChange={onValidate}
        resolveValue={readValue}
        callbackMap={resolvers.resolveCallbackMap}
        componentMap={resolvers.resolveComponentMap}
        classNameMap={resolvers.resolveClassNameMap}
      />
    </WizardPage>
  );
}

TinyHomesPage.propTypes = wizardProps;
export default withViewModelService(TinyHomesPage);

